import React, { useEffect, useState } from "react";
import { useAuth } from "../../../AuthContext";
import { useNavigate } from "react-router-dom";
import api from "../../../api/axios.js";

export default function Messages() {
  const { user, loading } = useAuth();
  const [conversations, setConversations] = useState([]);
  const [isEmpty, setIsEmpty] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (loading || !user) return;

    const fetchConversations = async () => {
      try {
        const res = await api.get("/conversations");
;
        if (!res.data || res.data.length === 0) {
          setIsEmpty(true);
          setConversations([]);
          return;
        }

        const formatted = res.data.map((conv) => {
          const isUserOne = conv.user_one_id === user.id;
          const otherUser = isUserOne ? conv.user_two : conv.user_one;

          return {
            id: conv.id,
            otherUserId: otherUser?.id ?? null,
            name: otherUser?.name ?? "مستخدم غير معروف",
            profileImage: otherUser?.profile_image ?? null,
            lastMessage:
              conv.messages && conv.messages.length > 0
                ? conv.messages[0].message
                : "لا توجد رسائل بعد",
          };
        });

        setConversations(formatted);
        setIsEmpty(formatted.length === 0);
      } catch (error) {
        console.error("خطأ في جلب المحادثات:", error);
        setIsEmpty(true);
      }
    };

    fetchConversations();
  }, [user, loading]);

  if (loading)
    return <p className="text-center mt-10">⏳ جارِ التحميل...</p>;

  if (!user)
    return (
      <p className="text-center mt-10 text-red-500">
        ⚠️ يجب تسجيل الدخول أولاً
      </p>
    );

  return (
    <div className="max-w-lg mx-auto mt-12 bg-gradient-to-r from-blue-50 to-blue-100 rounded-3xl shadow-2xl p-8">
      <h1 className="text-3xl font-extrabold text-center mb-8 text-blue-700">
        المحادثات
      </h1>

      {isEmpty ? (
        <p className="text-center text-gray-500 italic">
          لا توجد محادثات بعد
        </p>
      ) : (
        <ul className="space-y-4">
          {conversations.map((conv) => {
            if (!conv.otherUserId) return null;

            return (
              <li
                key={conv.id}
                onClick={() => navigate(`/chat/${conv.otherUserId}`)}
                className="flex items-center p-4 bg-white rounded-2xl shadow hover:bg-blue-50 cursor-pointer transition"
              >
                {/* Avatar */}
                {conv.profileImage ? (
                  <img
                    src={conv.profileImage}
                    alt={conv.name}
                    className="w-14 h-14 rounded-full object-cover mr-4"
                  />
                ) : (
                  <div className="w-14 h-14 bg-blue-600 text-white rounded-full flex items-center justify-center font-bold text-lg mr-4">
                    {conv.name.charAt(0)}
                  </div>
                )}

                {/* Infos */}
                <div className="flex flex-col overflow-hidden">
                  <span className="font-semibold text-gray-800">
                    {conv.name}
                  </span>
                  <span className="text-gray-500 text-sm truncate">
                    {conv.lastMessage}
                  </span>
                </div>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
